import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getBlackoutPeriod = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `blackout-period/${domain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}